import React, { Component } from 'react';
import { connect } from 'react-redux';

export default connect(store => ({
  cypress: store.cypress,
}))(
  class Cypress extends Component {
    render() {
      return (
        <div>
          {this.props.cypress.responses.map(res => (
            <input key={res.url} id={res.key} type="hidden" value={res.data} />
          ))}
        </div>
      );
    }
  }
);
